<script>
import CoreComponent from "../../../../../../../dow-platform/ui.frontend/src/dow-platform/components/core/CoreComponent.vue";

export default {
    extends: CoreComponent,
    methods: {
        closeOtherDropdowns() {
			$('.country-finder').find('.filters__dropdown').removeClass('active');
			$('.country-finder').find('.filters__filter-by').removeClass('active');
		},

        setNewSelectedCountry(countryCode, countryTitle) {
			$("#country-dropdown").text(countryTitle);
			$('.corp-country-item').addClass('hidden');
			if (countryCode !== ''){
				$('.' + countryCode).removeClass('hidden');
			}
		},

        setNewSelectedRegion(regionCode, regionTitle) {
			this.setNewSelectedCountry('', 'Country');
			$("#region-dropdown").text(regionTitle);
			$('.corp-country-item-dd').addClass('hidden');
			$('.' + regionCode).removeClass('hidden');
		},

		sortRegions() {
			const ul = this.cmpEl.querySelector('#region ul');
			const items = Array.from(ul.getElementsByTagName('li'));
			items.sort((a, b) => a.getAttribute("value").trim().localeCompare(b.getAttribute("value").trim()));
			items.forEach(li => ul.appendChild(li));
		}

    },
    mounted() {
        this.closeOtherDropdowns()
		this.sortRegions();

		window.onclick = (event) => {
			if (!$(event.target).is('.filters__filter-by')){
				this.closeOtherDropdowns();
			}
		}

		$(".country__title").on("click", (event) => {
			event.preventDefault();
			$(event.target).closest("a").toggleClass("country__title--active");
			$(event.target).siblings().toggleClass("country__list--active");
		});	

		$(".filters__filter-by").on("click", (event) => {
			event.preventDefault();
			$(event.target).closest("a").toggleClass("active");
			$(event.target).siblings().toggleClass("active");
		});	

		$(".corp-country-item-dd").on("click", (event) => {
			var countryCode = $(event.target).closest("li").attr("value");
			var countryTitle= $(event.target).closest("li").text();
			this.setNewSelectedCountry(countryCode, countryTitle);
			event.preventDefault();
		});

		$(".corp-region-item-dd").on("click", (event) => {
			var regionCode = $(event.target).closest("li").attr("value");
			var regionTitle= $(event.target).closest("li").text();
			this.setNewSelectedRegion(regionCode, regionTitle);
			event.preventDefault();
		});
    }
};

</script>

<style lang="scss">
@import "./countryFinder.scss";
</style>
